/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VirtualServiceModalModule
 */

const moduleName = 'virtualService';
const componentName = 'vs-attach-waf-in-eval-mode';
const prefix = `${moduleName}.${componentName}`;

export const headerText = `${prefix}.headerText`;
export const descriptionText = `${prefix}.descriptionText`;
export const creationSectionTitle = `${prefix}.creationSectionTitle`;
export const attachingSectionTitle = `${prefix}.attachingSectionTitle`;
export const wafPolicyLabel = `${prefix}.wafPolicyLabel`;
export const wafProfileLabel = `${prefix}.wafProfileLabel`;
export const noteText = `${prefix}.noteText`;
export const questionText = `${prefix}.questionText`;
export const cancelButtonLabel = `${prefix}.cancelButtonLabel`;
export const continueButtonLabel = `${prefix}.continueButtonLabel`;

export const ENGLISH = {
    [headerText]: 'WAF Evaluation',
    [descriptionText]: 'This will create a WAF policy in Evaluation mode, it will sample your traffic by using otherwise unused CPU resources and give you insights how a WAF could help you.',
    [creationSectionTitle]: 'The Following will be created and attached:',
    [attachingSectionTitle]: 'The Following will be attached:',
    [wafPolicyLabel]: 'WAF Policy',
    [wafProfileLabel]: 'WAF Profile',
    [noteText]: 'At any point you can remove the WAF policy to return Virtual Service to its original state.',
    [questionText]: 'Would you like to continue?',
    [cancelButtonLabel]: 'CANCEL',
    [continueButtonLabel]: 'YES, CONTINUE',
};

